export const appConfig = {
  appName: 'PACE',
  appDescription: 'PACE Conversational AI Assistant',
  appVersion: '1.0.0',
  appAuthor: 'PACE',
  appAuthorEmail: 'info@pace.ai',
  appAuthorUrl: 'https://www.pace.ai',
  appInputPlaceholder: 'Consult with PACE',
  appMessageImage:'/images/message_profile.jpeg',
  appSuggestedPrompts: [
    {
      text: 'Consult with PACE',
    },
    {
      text: 'What can you do?',
    },
    {
      text: 'How can you help me?',
    },
    {
      text: 'Tell me about yourself',
    },
  ],
};
